import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Purchase} from './purchases';

@Injectable()
export class PurchaseService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('purchases?' + params.toString()).map((response: Response) => response.json());
    }
    deletePic(_id: string) {
        return this.http.put('org/picture/delete/' + _id,{}).map((response: Response) => response.json());
    }
    deletePic1(_id: string) {
        return this.http.put('org/picture/delete1/' + _id,{}).map((response: Response) => response.json());
    }
    getAllCurrencies() {
        return this.http.get('all/currencies').map((response: Response) => response.json());
    }
    getLogo() {
        return this.http.get('purchases/logo').map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('purchases/' + _id).map((response: Response) => response.json());
    }


    getTrashedById(_id: string) {
        return this.http.get('purchases/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('purchases/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(purchase: Purchase) {
        return this.http.post('purchases', purchase).map((response: Response) => response.json());
    }

    update(purchase: Purchase) {
        return this.http.put('purchases/' + purchase.id, purchase).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('purchases/' + _id).map((response: Response) => response.json());
    }

    getitemslist(_id) {
      return this.http.get('it/' + _id).map((response: Response) => response.json());
    }

    getpaymentlist(_id) {
      return this.http.get('pur/pay/' + _id).map((response: Response) => response.json());
    }

    getAllPurchases(){
      return this.http.get('all/purchases').map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/views/pro/purchases/purchases.service.ts